import {computed, reactive} from "vue";
import {useAppStore} from "@/store/modules/app";

export function useLayout(props,layoutList){
  const appStore = useAppStore();
  const setting = reactive({});
  //获取当前的布局
  const getLayout = computed(() => {
    if(props&&props.useLayout){
      //如果定义的layout 在系统布局里面才返回
      if(unref(layoutList).findIndex((propName)=>{
        return props.useLayout===propName
      })>=0){
        return  props.useLayout;
      }else{
        return "defaultFrame";
      }
    }
    if(unref(layoutList).findIndex((propName)=>{
      return appStore.layout===propName
    })>=0){
      return  appStore.layout;
    }else{
      return "defaultFrame";
    }
  });


  return {
    setting,
    getLayout
  }
}
